// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b1707e9c","453":"1eb0658a"}[chunkId] + ".chunk.js";
};